import type { Trade } from '@/models/registry';
import { tradeStore } from '@/models/stores';
import { TRADE_STATUSES, type TradeStatus } from '@/models/types';
import { compact, isEmpty } from 'lodash';
import { toJS } from 'mobx';
import { useMemo } from 'react';

export type TradeByStatus = Record<
  TradeStatus,
  {
    status: TradeStatus;
    count: number;
    trades: Trade[];
  }
>;

const useTrades = (): {
  trades: Trade[];
  tradesByStatus: TradeByStatus;
  // getTradeByShortId: (shortId: string) => Trade | undefined;
} => {
  const proxy = tradeStore.getTrades;
  console.log('useTrades proxy', proxy);

  const trades = useMemo(() => {
    const transformedTradeInAppraisals = proxy.map((t) => toJS(t));

    if (isEmpty(proxy)) {
      // DEV NOTE: on the first render of this hook, the proxy is empty
      // so we return the data from the query
      return [];
    }

    if (!Array.isArray(transformedTradeInAppraisals)) {
      return [];
    }

    return compact(transformedTradeInAppraisals);
  }, [proxy]);

  const tradesByStatus = useMemo(() => {
    if (!trades) return {} as TradeByStatus;

    return TRADE_STATUSES.reduce((acc: TradeByStatus, status) => {
      acc[status] = {
        status,
        count: trades.filter((trade: Trade) => trade.status === status).length,
        trades: trades.filter((trade: Trade) => trade.status === status),
      };
      return acc;
    }, {} as TradeByStatus);
  }, [JSON.stringify(trades)]);

  // const getTradeByShortId = useCallback(
  //   (shortId: string) => {
  //     return trades?.find((trade: Trade) => trade.short_id === shortId);
  //   },
  //   [JSON.stringify(trades)],
  // );

  return {
    trades,
    tradesByStatus,
    // getTradeByShortId,
  };
};

export default useTrades;
